export const FETCH_INVOICES = 'FETCH_INVOICES'
export const FETCH_INVOICE_LIST_SUCCESS = 'FETCH_INVOICE_LIST_SUCCESS'
export const SET_SEARCH_TEXT_INVOICES = 'SET_SEARCH_TEXT_INVOICES'
export const CHANGE_PAGE_INVOICES = 'CHANGE_PAGE'

export const CHANGE_STATUS = 'CHANGE_STATUS'
